module.exports = __webpack_public_path__ + "img/idiotsontopwordart.c0e8aec9.png";